import Container from 'components/Shop/Table/Container'
import Table from 'components/Shop/Table/Table'

Table.Container = Container

export default Table
